import omit from 'lodash/omit';

import { TabValue } from 'features/cost-report/components/CostReportTabs';
import { CostReportTab } from 'features/cost-report/types/common';
import { useIsReliabilityMetricsAvailableInBeta } from 'hooks/permissions/useIsReliabilityMetricsAvailableInBeta';

import { workloadsTabs } from '../constants';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useGetWorkloadDetailsEnabledTabs = (): {
  enabledTabs: CostReportTab[];
  tabs: Partial<Record<CostReportTab, TabValue>>;
} => {
  const { isKentManaged } = useCluster();
  const isReliabilityEnabled = useIsReliabilityMetricsAvailableInBeta();

  const enabledTabs: CostReportTab[] = [
    CostReportTab.COMPUTE_COST,
    CostReportTab.EFFICIENCY,
    CostReportTab.GPU_UTILIZATION,
  ];
  if (!isKentManaged) {
    enabledTabs.splice(1, 0, CostReportTab.NETWORK_COST);
  }

  if (isReliabilityEnabled) {
    enabledTabs.splice(1, 0, CostReportTab.RELIABILITY);
  }

  const tabs = isReliabilityEnabled
    ? workloadsTabs
    : omit(workloadsTabs, [CostReportTab.RELIABILITY]);

  return { enabledTabs, tabs };
};
